var map = {
	"./#6ee097.png": "./src/components/img/anotacao/#6ee097.png",
	"./#86b4f7.png": "./src/components/img/anotacao/#86b4f7.png",
	"./#E8D979.png": "./src/components/img/anotacao/#E8D979.png",
	"./#F095A1.png": "./src/components/img/anotacao/#F095A1.png",
	"./#F8F9FA.png": "./src/components/img/anotacao/#F8F9FA.png",
	"./#a0a2a3.png": "./src/components/img/anotacao/#a0a2a3.png",
	"./#b78ff2.png": "./src/components/img/anotacao/#b78ff2.png",
	"./#f28fe7.png": "./src/components/img/anotacao/#f28fe7.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/img/anotacao sync recursive ^\\.\\/.*\\.png$";